interface DefaultApplicationContainerProps {
    children: React.ReactNode;
}

export const DefaultApplicationContainer = (props: DefaultApplicationContainerProps) => {
    return <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>{props.children}</div>;
};
